import axios from "../../../context/axiosConfig";

const pozyczkiGetList = async (pagination) => {
	return axios.post("/pozyczki/get/list", {
		pagination,
	});
};

export default pozyczkiGetList;
